export default __webpack_public_path__ + "d67c9052a6d4f2e58db57c94eceeab8f.png";